export default "__VITE_ASSET__BKekO1gt__"